import { useContext } from '@nuxtjs/composition-api'
import VueI18n, {
  Choice,
  Locale,
  Path,
  TranslateResult,
  Values
} from 'vue-i18n'

export function useT(): VueI18n['t'] {
  const { app } = useContext()

  return (key: Path, values: Values | undefined | Locale): TranslateResult =>
    // @ts-ignore
    app.i18n.t(key, values)
}

export function useTc(): VueI18n['tc'] {
  const { app } = useContext()

  return (key: Path, choice?: Choice, values?: Values | Locale): string =>
    // @ts-ignore
    app.i18n.tc(key, choice, values)
}

export function useI18n(): VueI18n {
  return useContext().app.i18n as VueI18n
}
